/** @format */

import { createAction, props } from '@ngrx/store';
import { InventoryExceededStatus, SelectedWarranty } from '@pdp/data-access/interfaces';

export const userSetInputQuantity = createAction(
	'[Add To Cart] User Set Input Quantity',
	props<{ atcUserInputQuantity: string }>()
);

export const userSetFulfillmentOption = createAction(
	'[Add To Cart] User Set Fulfillment Option',
	props<{ atcFulfillmentOption: string }>()
);

export const addToCartSucceeded = createAction('[Add To Cart] Add To Cart Succeeded');

export const addToCartErrored = createAction('[Add To Cart] Add To Cart Errored');

export const fbtAddToCartSucceeded = createAction(
	'[Frequently Bought Together] FBT Add To Cart Succeeded'
);

export const fbtAddToCartErrored = createAction(
	'[Frequently Bought Together] FBT Add To Cart Errored'
);

export const addToCartTriggered = createAction('[Add To Cart] Add To Cart Triggered');

export const atcSuccessDrawerOpened = createAction('[ATC Success Drawer] Drawer Opened');

export const atcSuccessDrawerClosed = createAction('[ATC Success Drawer] Drawer Closed');

export const atcSnackbarClosed = createAction('[ATC Snackbar] Snackbar Closed');

export const atcAttemptedWithAttributeErrors = createAction(
	'[Add To Cart] ATC Attempted With Attribute Errors'
);

export const warrantyATCAttemptedWithAttributeErrors = createAction(
	'[Warranty Button] ATC Attempted With Attribute Errors'
);

export const inventoryExceeded = createAction(
	'[Add To Cart] Inventory Exceeded',
	props<{ maxInventory: InventoryExceededStatus['maxInventory'] }>()
);

export const inventoryNotExceeded = createAction('[Add To Cart] Inventory Not Exceeded');

export const quantityRangeValidationFailed = createAction(
	'[Add To Cart] Quantity Range Validation Failed',
	props<{ message: string }>()
);

export const quantityRangeValidationSucceeded = createAction(
	'[Add To Cart] Quantity Range Validation Succeeded'
);

export const atcDrawerWarrantyAddPlanClicked = createAction(
	'[Add To Cart Success Drawer] Warranty Add Plan Button Clicked',
	props<{ selectedWarranty: SelectedWarranty }>()
);

export const warrantyAddtoExistingCartSucceeded = createAction(
	'[Add To Cart Success Drawer] Warranty Add to Existing Cart Succeeded',
	props<{ selectedWarranty: SelectedWarranty }>()
);

export const warrantyAddToExistingCartErrored = createAction(
	'[Add To Cart Success Drawer] Warranty Add to Existing Cart Errored'
);
